/**
 * .925 Odkazy v menu – externé stránky (NotebookLM…) po ruke z CRM.
 * Otvárajú sa v novej karte. Administrátor ich upraví priamo tu.
 */
import { useEffect, useState } from 'react';
import { ExternalLink, Pencil, Plus, Trash2 } from 'lucide-react';
import { api } from '../api';
import { Modal, useToast } from './ui';

const NAZVY_ROL = { admin: 'Administrátor', user: 'Zamestnanci', obchodnik: 'Obchodný zástupca' };

export default function MenuOdkazy({ user }) {
  const toast = useToast();
  const [odkazy, setOdkazy] = useState([]);
  const [uprava, setUprava] = useState(null);
  const smie = ['admin', 'user', 'obchodnik'].includes(user?.role);
  const nacitaj = () => api.get('/api/odkazy').then((v) => setOdkazy(v.odkazy || [])).catch(() => {});
  useEffect(() => { if (smie) nacitaj(); }, [smie]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!smie || (!odkazy.length && user.role !== 'admin')) return null;

  const otvorUpravu = async () => {
    try { const v = await api.get('/api/odkazy/vsetky'); setUprava(v.odkazy.map((o) => ({ ...o }))); }
    catch (e) { toast.error(e.message); }
  };
  const uloz = async () => {
    try { await api.put('/api/odkazy', { odkazy: uprava }); setUprava(null); nacitaj(); toast.success('Odkazy uložené.'); }
    catch (e) { toast.error(e.message); }
  };
  const zmen = (i, k, v) => setUprava((z) => z.map((o, j) => (j === i ? { ...o, [k]: v } : o)));

  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {odkazy.map((o) => (
        <a key={o.id || o.url} href={o.url} target="_blank" rel="noopener noreferrer" title={`${o.nazov} – otvorí sa v novej karte`}
          className="inline-flex min-w-0 max-w-full items-center gap-1.5 rounded-lg bg-slate-800 px-2.5 py-1.5 text-xs font-medium text-slate-200 ring-1 ring-slate-700 transition hover:bg-slate-700 hover:text-white">
          <ExternalLink size={13} className="shrink-0" /> <span className="truncate">{o.nazov}</span>
        </a>
      ))}
      {user.role === 'admin' && (
        <button className="inline-flex items-center gap-1 rounded-lg px-2 py-1.5 text-xs text-slate-500 hover:bg-slate-800 hover:text-white"
          title="Upraviť odkazy v menu" onClick={otvorUpravu}>
          {odkazy.length ? <Pencil size={12} /> : <><Plus size={12} /> odkaz</>}
        </button>
      )}
      <Modal open={!!uprava} onClose={() => setUprava(null)} title="Odkazy v menu" size="max-w-2xl"
        footer={<><button className="btn-ghost" onClick={() => setUprava(null)}>Zrušiť</button><button className="btn-primary" onClick={uloz}>Uložiť</button></>}>
        <div className="space-y-3">
          <p className="text-sm text-slate-500">Stránky, ktoré majú byť po ruke z CRM. Otvoria sa v novej karte; prihlásenie do nich má každý svoje.</p>
          {(uprava || []).map((o, i) => (
            <div key={i} className="space-y-2 rounded-lg p-3 ring-1 ring-slate-200">
              <div className="flex gap-2">
                <input className="input w-48" placeholder="Názov" value={o.nazov || ''} onChange={(e) => zmen(i, 'nazov', e.target.value)} />
                <input className="input flex-1" placeholder="https://…" value={o.url || ''} onChange={(e) => zmen(i, 'url', e.target.value)} />
                <button className="text-slate-400 hover:text-rose-600" title="Odobrať" onClick={() => setUprava((z) => z.filter((_, j) => j !== i))}><Trash2 size={16} /></button>
              </div>
              <div className="flex flex-wrap gap-3 text-xs text-slate-600">
                Vidí:
                {Object.entries(NAZVY_ROL).map(([k, l]) => (
                  <label key={k} className="flex items-center gap-1">
                    <input type="checkbox" checked={(o.role || []).includes(k)} disabled={k === 'admin'}
                      onChange={(e) => zmen(i, 'role', e.target.checked ? [...new Set([...(o.role || []), k])] : (o.role || []).filter((r) => r !== k))} />
                    {l}
                  </label>
                ))}
              </div>
            </div>
          ))}
          <button className="btn-ghost text-sm" onClick={() => setUprava((z) => [...(z || []), { nazov: '', url: '', role: ['admin'] }])}><Plus size={14} /> Pridať odkaz</button>
        </div>
      </Modal>
    </div>
  );
}
